import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const DATADOG_MONITOR_PAGE_URLS = {
  datadog: 'https://app.datadoghq.com/monitors',
  datadog_us3: 'https://us3.datadoghq.com/monitors',
  datadog_us5: 'https://us5.datadoghq.com/monitors',
  datadog_eu: 'https://app.datadoghq.eu/monitors',
  datadog_us1_fed: 'https://app.ddog-gov.com/monitors'
}

export const ENDPOINT_URLS = {
  datadog: 'https://app.datadoghq.com/api/',
  datadog_us3: 'https://us3.datadoghq.com/api/',
  datadog_us5: 'https://us5.datadoghq.com/api/',
  datadog_eu: 'https://app.datadoghq.eu/api/',
  datadog_us1_fed: 'https://app.ddog-gov.com/api/',
  newrelic: 'https://api.newrelic.com/',
  pagerduty: 'https://api.pagerduty.com/',
  k6: 'https://api.k6.io/'
}

export const ADDITIONAL_KNOWN_URLS = {
  datadog: ['https://api.datadoghq.com/api/'],
  datadog_eu: ['https://api.datadoghq.eu/api/']
}

export const DOMAIN_NAME_INTEGRATIONS: IntegrationType[] = [
  IntegrationType.Grafana,
  IntegrationType.Dynatrace,
  IntegrationType.Appdynamics
]
